"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var throwErrors = function throwErrors(_ref) {
  var id = _ref.id,
      infiniteScroll = _ref.infiniteScroll,
      dialog = _ref.dialog,
      buttons = _ref.buttons;

  if (process.env.NODE_ENV === 'development') {
    if (infiniteScroll && !id) {
      throw new Error('ERROR: You must pass an id to Modal when using infinite scroll.', 'In the InfiniteScroll component, pass that id to the prop scrollableTarget.');
    }

    if (dialog && !buttons.primaryOnClick) {
      throw new Error('ERROR: Dialog Modal must have buttons.');
    }
  }
};

var _default = throwErrors;
exports["default"] = _default;